export default __webpack_public_path__ + "e622f535d6fd8fa71d335be4f6db7dcc.svg";